<script>
import { authComputed } from '@state/helpers'

export default {
	components: {
	},
	props: {
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		isMenuOpened: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			admin: {}
		}
	},
	computed: {
		...authComputed,
	},
	methods: {
		toggleMenu() {
			this.$parent.toggleMenu()
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar()
		},
	},
	mounted() {
    	this.admin = this.$store.state.auth.currentUser.data.user
  	},
}
</script>

<template>
	<!-- Topbar Start -->
	<div class="navbar navbar-expand shadow flex-column flex-md-row navbar-custom">
		<div class="container-fluid">
			<!-- LOGO -->
			<a href="/" class="navbar-brand mr-0 mr-md-2 logo">
				<span class="logo-lg">
					<img src="@assets/images/logoCJ.png" alt height="50" />
					<!-- <span class="d-inline h5 ml-2">F&N Nomaroi</span> -->
				</span>
				<span class="logo-sm">
					<img src="@assets/images/logoCJ.png" alt height="50" />
				</span>
			</a>

			<ul
				class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0"
			>
				<li class>
					<button
						class="button-menu-mobile open-left disable-btn"
						:class="{ open: isMenuOpened }"
						@click="toggleMenu"
					>
						<feather type="menu" class="menu-icon align-middle"></feather>
						<feather type="x" class="close-icon"></feather>
					</button>
				</li>
			</ul>

			<ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">
				<li class="d-none d-sm-block">
					<div class="media user-profile mt-2 mb-2" style="padding:15px 0px">
						<div class="media-body mr-2 text-right">
							<h6 class="pro-user-name mt-0 mb-0">{{ admin.firstName + ' ' + admin.lastName }}</h6>
							<span class="pro-user-name">{{ admin.email }}</span>
						</div>
						<img
							src="@assets/images/users/avatar-7.jpg"
							class="avatar-sm rounded-circle mr-2"
							alt="Shreyu"
						/>
						<img
							src="@assets/images/users/avatar-7.jpg"
							class="avatar-xs rounded-circle mr-2"
							alt="Shreyu"
						/>
						<b-dropdown right variant="black" class="align-self-end" toggle-class="p-0">
							<template v-slot:button-content>
								<feather type="chevron-down" class="align-middle"></feather>
							</template>

							<b-dropdown-item href="/myaccount" class="notify-item">
								<feather
									type="user"
									class="icon-dual icon-xs mr-2 align-middle"
								></feather>
								<span>My Account</span>
							</b-dropdown-item>

							<b-dropdown-divider></b-dropdown-divider>

							<b-dropdown-item href="/logout" class="notify-item">
								<feather
									type="log-out"
									class="icon-dual icon-xs mr-2 align-middle"
								></feather>
								<span>Logout</span>
							</b-dropdown-item>
						</b-dropdown>
					</div>
				</li>
			</ul>
		</div>
	</div>
	<!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
	height: 220px;
}
.ps > .ps__scrollbar-y-rail {
	width: 8px !important;
	background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
	width: 6px !important;
}
.button-menu-mobile {
	outline: none !important;
}

@media (max-width: 1024px) {
	.navbar-custom .logo {
		display: unset !important;
	}
	.topnav-menu {
		display: none !important;
	}
}

.navbar-custom .button-menu-mobile {
	margin-right: 0px;
}
</style>
